var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"wizard-step"},_vm._l((_vm.steps),function(step){return _c('li',{key:step,class:{ active: step === _vm.active }},[_vm._v(" "+_vm._s(step)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }